import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import SubActivityView from 'approot/activity-builder/components/sub-activity/sub-activity-view';
import {
  ClassroomAnswerInstruction,
  ClassroomSuggestedAnswer,
} from '../classroom-answer.style';
import {
  ACTIVITIES_BASE_HEIGHT_SMALL,
  SUGGESTED_ANSWER_EXAMPLE,
} from 'global/constants';
import { getAnswerTypeLabel } from 'approot/activity-builder/components/suggested-answers/logic/get-answer-type-label';
import { ResponseFieldReadonly } from 'approot/activity-builder/components/response/response-field-readonly.style';
import { getRichtextValue } from 'approot/activity-builder/components/shared/logic/get-richtext-value';
import { SUGGESTED_ANSWER_BASE_RICHTEXT } from 'approot/activity-builder/components/suggested-answers/suggested-answer.constants';
import { useGetRichtextAnswer } from 'approot/activity-builder/components/suggested-answers/suggested-answer.hooks';
import {
  ComponentInteractiveResponseCategorise,
  ComponentInteractiveResponseSequence,
} from 'approot/activity-builder/components/component.constants';

type Props = {
  component: Omit<
    | ComponentInteractiveResponseCategorise
    | ComponentInteractiveResponseSequence,
    '__typename'
  >;
};

const InteractiveResponseSuggestedAnswers = ({ component }: Props) => {
  const { suggestedAnswerProperties } = component;

  const answerType =
    suggestedAnswerProperties?.suggestedAnswerType || SUGGESTED_ANSWER_EXAMPLE;

  const answer = useGetRichtextAnswer({
    componentId: component.id,
    suggestedAnswerProperties,
  });

  const answerTypeBadge = (
    <BadgeSmallStyled>{getAnswerTypeLabel(answerType)}</BadgeSmallStyled>
  );

  return (
    <ClassroomAnswerInstruction>
      <SubActivityView subActivityDetails={component.subActivityProperties}>
        {answerType === SUGGESTED_ANSWER_EXAMPLE && (
          <ClassroomSuggestedAnswer>
            <ResponseFieldReadonly
              $numberOflines={1}
              $baseHeight={ACTIVITIES_BASE_HEIGHT_SMALL}
              dangerouslySetInnerHTML={{
                __html: getRichtextValue(
                  answer,
                  SUGGESTED_ANSWER_BASE_RICHTEXT
                ),
              }}
            />
            {answerTypeBadge}
          </ClassroomSuggestedAnswer>
        )}
      </SubActivityView>
    </ClassroomAnswerInstruction>
  );
};

export default InteractiveResponseSuggestedAnswers;
